import { PureComponent } from "react";
import BoardsCarouselComponent from "./boards-carousel/boards-carousel-component";

import { componentStyles } from "./boards-and-quotes-carousel-component.scss";

export default class BoardsAndQoutesCarouselComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { active: 0 };
    this.setActive = this.setActive.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeIndex != this.state.active) {
      this.setState({ active: nextProps.activeIndex });
    }
  }

  setActive(active) {
    const { setActive } = this.props;
    if (setActive) {
      setActive(active);
    } else {
      this.setState({ active });
    }
  }

  render() {
    const { quotes, stopAutoSlide, startAutoSlide, showNavigationArrows, removeBoardBorder, aboveTheFold } = this.props;

    const active = Math.min(quotes.length - 1, this.state.active);
    if (!quotes[active]) return false;

    return (
      <div className="boards-and-quotes-carousel-component">
        <div className="boards-carousel-wrapper">
          <BoardsCarouselComponent
            quotes={quotes}
            active={active}
            setActive={this.setActive}
            stopAutoSlide={stopAutoSlide}
            startAutoSlide={startAutoSlide}
            showNavigationArrows={showNavigationArrows}
            removeBoardBorder={removeBoardBorder}
            aboveTheFold={aboveTheFold}
          />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

BoardsAndQoutesCarouselComponent.defaultProps = {
  quotes: []
};
